// extracted by mini-css-extract-plugin
module.exports = {"root":"EventPage_root__3GbGf","submitButton":"EventPage_submitButton__14opw","selectcontrol":"EventPage_selectcontrol__2Glrp"};